// Строки бокового меню (10.09, переделано 23.10): чаты сайта и умные помощники одним списком. Помощник — одна строка
// на него (имя, аватарка), пока есть хоть одна своя работа; клик открывает последнюю. Закреплённые — наверху (и
// чаты, и помощники: у помощника та же скрепка, что в рельсе раздела), дальше — по времени последней активности.
import type { SidebarAssistant } from '../api/assistants'
import type { ChatSessionItem } from '../api/chat'

function ts(iso: string | null | undefined): number {
	if (!iso) return 0
	const t = new Date(iso.endsWith('Z') || iso.includes('+') ? iso : `${iso}Z`).getTime()
	return Number.isNaN(t) ? 0 : t
}

/** id строки помощника в списке: по помощнику, не по работе — строка живёт, пока работы меняются. */
export const agentRowId = (agentId: string) => `agent:${agentId}`

export function assistantRow(a: SidebarAssistant): ChatSessionItem {
	const updated = a.updated_at || a.created_at || new Date().toISOString()
	return {
		id: agentRowId(a.agent_id), title: a.agent_title, model: null, provider: null, message_count: 0, is_pinned: a.pinned,
		created_at: a.created_at || updated, updated_at: updated,
		agent_id: a.agent_id, agent_title: a.agent_title, agent_icon_url: a.agent_icon_url, context_mode: '10k', kind: 'assistant',
		agent_slug: a.agent_slug, run_id: a.run_id,
	}
}

export function mergeSidebarRows(sessions: ChatSessionItem[], assistants: SidebarAssistant[]): ChatSessionItem[] {
	const rows = assistants.length ? [...sessions, ...assistants.map(assistantRow)] : [...sessions]
	return rows.sort((a, b) => Number(!!b.is_pinned) - Number(!!a.is_pinned) || ts(b.updated_at) - ts(a.updated_at))
}
